import { useState } from "react"

export const AgentApplicationState = () => {
	const [agents, setAgents] = useState({
        agentsList: [],
        agentsLoader: false,
        agentsModal: false,
        agentsInftScroll: true,
        agentsIsLoading: false,
        agentsCooldown: false,
        agentsHasMore: true,
        agentsLastId: 0,
    })
	return {
		agents: { data: agents, set: setAgents },
	}
}
